/* ------------------------------------------------------------
 * GT Home — category carousel pagination (sections/gt-home-categories.liquid).
 *
 * Scrolling itself is pure CSS (scroll-snap). This only moves the active
 * pagination pill to the card nearest the current scroll position. No
 * dependencies. A custom element, so Theme Editor re-renders disconnect the
 * old instance (listener removed) and connect a fresh one.
 * ------------------------------------------------------------ */
(function () {
  'use strict';

  if (typeof customElements === 'undefined' || customElements.get('gt-hc-carousel')) return;

  class GtHcCarousel extends HTMLElement {
    constructor() {
      super();
      this.frame = 0;
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.list = this.querySelector('[data-gt-hc-list]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gt-hc-dot]'));
      if (!this.list || this.dots.length < 2) return;
      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(this.update);
    }

    update() {
      this.frame = 0;
      var list = this.list;
      var items = list.children;
      if (!items.length) return;
      var max = list.scrollWidth - list.clientWidth;
      var index = 0;
      if (max > 0 && list.scrollLeft >= max - 2) {
        index = items.length - 1;
      } else {
        var start = items[0].offsetLeft;
        var best = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - start - list.scrollLeft);
          if (d < best) {
            best = d;
            index = i;
          }
        }
      }
      for (var j = 0; j < this.dots.length; j++) {
        this.dots[j].classList.toggle('is-active', j === index);
      }
    }
  }

  customElements.define('gt-hc-carousel', GtHcCarousel);
})();
